// Monotonic "login epoch". Incremented on each successful CUSTOMER login. The WelcomeAnimation
// captures the epoch at render time (pure read — StrictMode-safe) to decide whether it mounted
// because of a fresh login (epoch > 0) vs a plain refresh/navigation (module reloads → epoch 0).
// Deliberately NOT persisted: a full page refresh resets it, so the welcome only plays on an
// actual login event, and it plays on EVERY login (no "already seen" restriction).
let loginEpoch = 0;

export const markCustomerLogin = () => { loginEpoch += 1; };

export const getLoginEpoch = () => loginEpoch;
